export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-4">
            关于酷漫屋
          </h2>
          <div className="w-12 h-1 bg-primary-500 mx-auto mb-6"></div>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            酷漫屋是一个专注<strong className="text-foreground-800 font-semibold">下拉式竖屏漫画阅读</strong>的在线平台，致力于为漫画爱好者提供最流畅舒适的条漫阅读体验。我们相信，漫画阅读应该是轻松、沉浸且无需等待的——只需向下滑动，故事就在指尖展开。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            平台收录涵盖<strong className="text-foreground-800 font-semibold">日本漫画、韩国条漫和国漫精品</strong>，从热血战斗到恋爱甜宠，从悬疑推理到奇幻冒险，我们在持续拓展内容库的深度和广度。截至目前，酷漫屋已收录超过<strong className="text-foreground-800 font-semibold">8000部漫画作品</strong>，每日内容更新频次稳定在<strong className="text-foreground-800 font-semibold">300话以上</strong>，为读者提供源源不断的新鲜阅读内容。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            我们的团队始终秉持<strong className="text-foreground-800 font-semibold">免费阅读</strong>的初心，不断优化移动端竖屏适配、提升图片加载速度、丰富内容推荐算法。无论你是在通勤路上、午后茶歇还是深夜被窝，酷漫屋都希望能成为你最贴心的条漫阅读伴侣。
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
            <div className="bg-background-100 rounded-lg p-4">
              <div className="text-xl md:text-2xl font-heading text-primary-500 mb-1">8000+</div>
              <div className="text-xs text-foreground-600">收录作品</div>
            </div>
            <div className="bg-background-100 rounded-lg p-4">
              <div className="text-xl md:text-2xl font-heading text-accent-500 mb-1">300+</div>
              <div className="text-xs text-foreground-600">每日更新话数</div>
            </div>
            <div className="bg-background-100 rounded-lg p-4">
              <div className="text-xl md:text-2xl font-heading text-primary-500 mb-1">50万+</div>
              <div className="text-xs text-foreground-600">日活跃读者</div>
            </div>
            <div className="bg-background-100 rounded-lg p-4">
              <div className="text-xl md:text-2xl font-heading text-accent-500 mb-1">全免费</div>
              <div className="text-xs text-foreground-600">阅读模式</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}